import { useQuery } from '@tanstack/react-query';
import type { ProductStatusCountsToken } from '@sleed/bizcommerce-api';
import { productsApi } from '~/lib/api/client';
import { productKeys } from '~/hooks/use-products-list';

/**
 * Saved-filter chip badge counts via `getStatusCounts`
 * (total / outOfStock / hidden / featured / noImage / newReleases).
 * Cached ~60s — these are coarse dashboard-style aggregates, not per-keystroke data.
 */
export function useProductCounts() {
	return useQuery<ProductStatusCountsToken>({
		queryKey: productKeys.counts(),
		staleTime: 60_000,
		queryFn: async () => {
			const res = await productsApi.getStatusCounts();
			return res.data;
		}
	});
}
